import { Global, css } from '@emotion/react';

const globalStyles = css`
  :root {
    --color-bg-app: #fafafb;
    --color-bg-surface: #ffffff;
    --color-bg-muted: #f5f5f7;
    --color-text-primary: #1a1b1d;
    --color-text-secondary: #7f8083;
    --color-text-muted: #b0b1b4;
    --color-border: #e5e6e9;
    --color-border-strong: #d4d5d8;
    --color-primary: #ff5a5f;
    --color-primary-bg: #ffebec;
  }

  html.dark {
    --color-bg-app: #0e0e10;
    --color-bg-surface: #1a1b1d;
    --color-bg-muted: #2f3033;
    --color-text-primary: #f5f5f7;
    --color-text-secondary: #b0b1b4;
    --color-text-muted: #7f8083;
    --color-border: #4b4c4f;
    --color-border-strong: #656669;
    --color-primary: #ff7a7e;
    --color-primary-bg: rgba(255, 90, 95, 0.16);
  }

  body {
    background: var(--color-bg-app);
    color: var(--color-text-primary);
  }

  /*
   * antd Table 글로벌 강제 스타일.
   * cssVar + algorithm 동적 전환 환경에서 라이트/다크 토큰이 잔존하는 회귀를 막기 위해
   * 모든 antd Table에 일관된 배경색을 강제한다. 페이지/컴포넌트 css에서 더 좁은 selector로
   * override할 수 있다 (예: DataTable 컴포넌트의 emotion css).
   */
  .ant-table-wrapper .ant-table {
    background: transparent;
  }

  .ant-table-wrapper .ant-table-thead > tr > th,
  .ant-table-wrapper .ant-table-thead > tr > td {
    background: var(--color-bg-muted) !important;
    color: var(--color-text-secondary);
  }

  .ant-table-wrapper .ant-table-tbody > tr > td {
    background: var(--color-bg-surface);
  }

  .ant-table-wrapper .ant-table-tbody > tr:hover > td,
  .ant-table-wrapper .ant-table-tbody > tr.ant-table-row-hover > td,
  .ant-table-wrapper .ant-table-tbody > tr > td.ant-table-cell-row-hover {
    background: var(--color-bg-muted) !important;
  }

  .ant-table-wrapper .ant-table-tbody > tr.ant-table-row-selected > td,
  .ant-table-wrapper .ant-table-tbody > tr.ant-table-row-selected:hover > td {
    background: var(--color-bg-muted) !important;
  }

  .ant-table-wrapper .ant-table-column-sort,
  .ant-table-wrapper .ant-table-cell-sort-active {
    background: var(--color-bg-muted) !important;
  }
`;

function ThemeGlobalStyles() {
  return <Global styles={globalStyles} />;
}

export default ThemeGlobalStyles;
